import React from 'react';
import ClerkLogIn from './ClerkLogIn';
import AuthTemplate from '../../common/auth-template/AuthTemplate';

const LogIn = () => {
  return <AuthTemplate>{<ClerkLogIn />}</AuthTemplate>;
};

export default LogIn;
